<app-card icon="group" title="Agent Information" iconGradient="from-indigo-500 to-purple-600" class="h-full">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <app-excel-button [data]="exportData()" [excelTitle]="'agent-information'" [columns]="cols"></app-excel-button>
        </div>
    </ng-template>
    <app-table-component
        [cols]="cols"
        [data]="agentInformationData() || []"
        [loading]="loading()"
        [oddRowColor]="'#e9f1f8'"
    ></app-table-component>
</app-card>

<ng-template #priceColumnTemplate let-rowData="rowData">
    <span>{{ rowData.revenue.amount | currency: rowData.revenue.currency }}</span>
</ng-template>
